export default function DigSection() {
  return (
    <section id="dig" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-64 w-full overflow-hidden lg:h-full lg:min-h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20life%20of%20an%20investigation%20board%20with%20pinned%20blank%20cards%20and%20string%20connections%20on%20a%20dark%20wall%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20minimal%20restrained%20composition%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20subtle%20film%20grain%2C%20mysterious%20mood%2C%20no%20text%2C%20no%20people&width=1200&height=900&seq=gossip-dig-01&orientation=landscape"
                alt="独家深挖 · 线索梳理现场"
                title="独家深挖 线索梳理 - 黑料网曝内幕"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="flex flex-col justify-center p-6 md:p-10 lg:p-12">
              <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-primary-700">
                <i className="ri-search-eye-line text-[14px]" />
                IN-DEPTH
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px]">
                独家深挖：把四条互相矛盾的时间线摆在同一张桌上
              </h2>
              <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-[14.5px]">
                争议之所以难有结论，往往不是信息太少，而是信息太杂。我们从公开物料、通告记录与可复核的第三方描述出发，
                只保留能被两个以上独立来源支撑的部分，再把它们按时间重新排序。
              </p>

              <ul className="mt-6 space-y-3.5">
                {[
                  '只收录可交叉验证的线索，孤证一律标注待核实',
                  '时间线按一手记录为准，传闻仅作背景补充',
                  '每期保留修订记录，更正内容不会被悄悄抹掉',
                ].map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-900">
                      <i className="ri-check-line text-[13px]" />
                    </span>
                    <span className="font-body text-[13.5px] leading-relaxed text-foreground-700">
                      {point}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8">
                <a
                  href="#dig"
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-[13.5px] font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  进入深挖专题
                  <i className="ri-arrow-right-line text-[16px]" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}